// extracted by mini-css-extract-plugin
export default {"newsSection":"NewsSection_newsSection__z+Y6W","title":"NewsSection_title__eDx9F","cardWrapper":"NewsSection_cardWrapper__U7hBT","buttonWrapper":"NewsSection_buttonWrapper__2QKVM"};